/**
 * Create request query from object, e.g. ?key1=value1&key2=value2
 *
 * @param {object} obj
 * @returns {string}
 */
export function concantQuery (obj) {
  if (typeof obj !== 'object') return ''

  const query = Object.keys(obj)
    .reduce((_query, key) => {
      return obj[key] ? _query + `${key}=${obj[key]}&` : _query
    }, '')

  return query.length > 0 ? '?' + query.replace(/&$/, '') : query
}
